export default __webpack_public_path__ + "static/media/SquareDiagonal.f45b2bb0.svg";